import { useEffect, useState, useRef } from 'react';
import './ComboCounter.css';

interface Props {
  count: number;
  onExpire?: () => void;
}

const HIDE_AFTER_MS = 3000;

export function ComboCounter({ count, onExpire }: Props) {
  const [pulse, setPulse] = useState(0);
  const [visible, setVisible] = useState(false);
  const prev = useRef(count);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;

  useEffect(() => {
    if (count > prev.current) {
      setPulse(p => p + 1);
    }
    prev.current = count;

    if (hideTimer.current) clearTimeout(hideTimer.current);
    if (count >= 3) {
      setVisible(true);
      hideTimer.current = setTimeout(() => {
        setVisible(false);
        onExpireRef.current?.();
      }, HIDE_AFTER_MS);
    } else {
      setVisible(false);
    }
    return () => {
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, [count]);

  if (!visible || count < 3) return null;
  return (
    <div className="combo-counter" key={pulse}>
      <span className="combo-x">×</span>
      <span className="combo-num">{count}</span>
      <span className="combo-label">COMBO</span>
    </div>
  );
}
